module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921005651_T.322206a7.jpg";